/* eslint-disable no-restricted-syntax */
const getClientXY = (e, changedTouches) => {
  const touchEventKey = changedTouches ? 'changedTouches' : 'touches';
  const { clientX, clientY } =
    e[touchEventKey]?.length > 0 ? e[touchEventKey][0] : e;

  return { clientX, clientY } || {};
};

export const getDirection = (absX, absY, deltaX) => {
  if (absX > absY) {
    if (deltaX > 0) {
      return 'left';
    }

    return 'right';
  }

  return null;
};

export const getChildItemTotalWidth = childrenRef => {
  const items = [];
  for (const child of childrenRef.current.children) {
    items.push(child.getBoundingClientRect()?.width);
  }

  return items.reduce((a, b) => a + b);
};

export const onStart = (e, updateEventData) => {
  const { clientX } = getClientXY(e);

  updateEventData({
    startClientX: clientX,
    isSwiping: true
  });
};

export const onEnd = (e, updateEventData) => {
  const { clientX } = getClientXY(e, true);

  updateEventData({
    endClientX: clientX,
    isSwiping: false
  });
};
